import $ from 'jquery';
window.addEventListener('px-ready',function(){
  $('.px-program-popup .program-bg, .px-program-popup .close').on('click',function(){
      $('.px-program-popup').removeClass('is-active');
  })
  $('.programcard').on('click',function(){
      console.log($(this).attr('data-program'))
      $('.px-program-popup[data-program="'+$(this).attr('data-program')+'"]').addClass('is-active')
  })
})